import type { FC } from "react"
import { BrowserRouter, Navigate, Route } from "react-router"
import { AuthenticatedLayout } from "./AuthenticatedLayout"
import { MetaTags } from "./components/MetaTags"
import { ErrorPage } from "./ErrorPage"
import { LoggedOutLayout } from "./LoggedOutLayout"
import {
  AdminDashboard,
  AdminLogin,
  AdminNotFound,
  AdminPurchaseDetail,
  AdminPurchaseList,
  AdminRestaurantInfo,
  AdminRestaurantLayout,
  AdminRestaurantList,
  AdminRestaurantSales,
  AdminRestaurantSalesFee,
  AdminRestaurantTicketDetail,
  AdminRestaurantTickets,
  AdminSettingMemberDetail,
  AdminSettingMemberNew,
  AdminSettingMembers,
  AdminSettingsLayout,
  AdminSettingTerms,
} from "./routes"
import { SentryRoutes } from "./sentry"

export const Routes: FC = () => {
  return (
    <BrowserRouter>
      <MetaTags />
      <SentryRoutes>
        <Route errorElement={<ErrorPage />}>
          <Route index element={<Navigate to="/dashboard" replace />} />

          <Route element={<LoggedOutLayout />}>
            <Route path="login" element={<AdminLogin />} />
          </Route>

          <Route element={<AuthenticatedLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />

            <Route path="restaurants">
              <Route index element={<AdminRestaurantList />} />
              <Route path=":restaurantId" element={<AdminRestaurantLayout />}>
                <Route index element={<Navigate to="info" replace />} />
                <Route path="sales" element={<AdminRestaurantSales />} />
                <Route path="info" element={<AdminRestaurantInfo />} />
                <Route path="shops/:shopId/tickets" element={<AdminRestaurantTickets />} />
                <Route
                  path="shops/:shopId/tickets/:ticketId"
                  element={<AdminRestaurantTicketDetail />}
                />
                <Route path="sales-fee" element={<AdminRestaurantSalesFee />} />
              </Route>
            </Route>

            <Route path="transactions">
              <Route index element={<AdminPurchaseList />} />
              <Route path=":purchaseId" element={<AdminPurchaseDetail />} />
            </Route>

            <Route path="setting" element={<AdminSettingsLayout />}>
              <Route index element={<Navigate to="members" replace />} />
              <Route path="members" element={<AdminSettingMembers />} />
              <Route path="members/new" element={<AdminSettingMemberNew />} />
              <Route path="members/:memberId" element={<AdminSettingMemberDetail />} />
              <Route path="terms" element={<AdminSettingTerms />} />
            </Route>

            <Route path="*" element={<AdminNotFound />} />
          </Route>
        </Route>
      </SentryRoutes>
    </BrowserRouter>
  )
}
